import { invalidateDefectTypesMasterCache } from '@/utils/defectTypesMasterCache';

/** 배포마다 바뀌는 앱 버전 — localStorage에 마지막 적용 버전 기록 */
export const APP_STORAGE_VERSION_KEY = 'solvit.appStorageVersion';

const PANEL_SITE_ID_KEY = 'solvit-panel-site-id';
const AI_LINEAR_PREFIX = 'solvit.aiDefectDisplayLinearRatio.';
const AI_PRESET_PREFIX = 'solvit.aiDefectDisplayPreset.';

/** 빌드 시 vue.config.js에서 주입. 로컬 dev는 고정 `dev`(HMR마다 초기화 방지). */
export function getAppStorageVersion() {
  return process.env.VUE_APP_VERSION || 'dev';
}

/** vuex-persist-indexeddb 키 — 버전이 바뀌면 이전 IndexedDB 상태와 분리된다. */
export function getVuexPersistStorageKey() {
  return `vuex-${getAppStorageVersion()}`;
}

function removeLocalStorageKeysByPrefix(prefix) {
  if (typeof localStorage === 'undefined') {
    return;
  }
  const toRemove = [];
  for (let i = 0; i < localStorage.length; i += 1) {
    const key = localStorage.key(i);
    if (key && key.startsWith(prefix)) {
      toRemove.push(key);
    }
  }
  toRemove.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch {
      /* noop */
    }
  });
}

function clearSessionScopedLocalStorage() {
  if (typeof localStorage === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(PANEL_SITE_ID_KEY);
  } catch {
    /* noop */
  }

  invalidateDefectTypesMasterCache();
  removeLocalStorageKeysByPrefix(AI_LINEAR_PREFIX);
  removeLocalStorageKeysByPrefix(AI_PRESET_PREFIX);
}

/**
 * 배포 버전 변경 시 세션성 localStorage만 비운다.
 * 유지: auth-token, 테마, locale, drawer width(별도 IndexedDB `solvit-ui`).
 * Vuex 상태는 persist key 변경으로 자동 초기화.
 */
export function applyClientStorageVersionMigration() {
  if (typeof localStorage === 'undefined') {
    return;
  }

  const current = getAppStorageVersion();
  const previous = localStorage.getItem(APP_STORAGE_VERSION_KEY);

  if (previous === current) {
    return;
  }

  clearSessionScopedLocalStorage();

  try {
    localStorage.setItem(APP_STORAGE_VERSION_KEY, current);
  } catch (e) {
    console.warn('[clientStorageVersion] failed to persist version:', e);
  }

  if (previous != null) {
    console.info(`[clientStorageVersion] migrated ${previous} → ${current}`);
  }
}
